// Generated by tools/design-tokens from design/figma. Do not edit.

/** The heart on Zumpo/Heart button: its box, and its outline as path data. */
export const HEART = {
  width: 16,
  height: 14,
  d: 'M8 14C8 14 0 9 0 4.2C0 1.8 1.8 0 4.2 0C5.8 0 7.2 0.9 8 2.2C8.8 0.9 10.2 0 11.8 0C14.2 0 16 1.8 16 4.2C16 9 8 14 8 14Z',
} as const;
